var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isIndicatorVisible)?_c('div',{class:_setup.indicatorClass},[_c('q-tooltip',[_vm._v(" "+_vm._s(_setup.tooltipText)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }